import { Fallback } from "@/components";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { API_BASE_URL, getResource } from "@/api/https";
import { createContext } from "@/lib";

export interface User {
  id: string;
  email: string;
  fullName: string;
}

type UserProvider = {
  user: User | null;
};

const [useProvider, Provider] = createContext<UserProvider>("RequireUser");

interface RequireUserProps extends React.PropsWithChildren {
  isOptional?: boolean;
}

export const RequireUser = ({ children, isOptional }: RequireUserProps) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        // Fetch user data from your API
        const userData = await getResource({ pathUrl: `${API_BASE_URL}user/me` });
        setUser(userData.data);
      } catch (error) {
        console.log(error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    const token = localStorage.getItem("authToken");
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <Fallback />;
  }

  if (!user && !isOptional) {
    return <Navigate to='/login' state={{ from: pathname }} replace />;
  }

  return <Provider user={user}>{children}</Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export { useProvider as useUser };
